<div *ngIf="controller && controller.invalid && controller.errors && (controller.dirty || controller.touched)" class="alert alert-danger {{class}}">
  <!-- <div [ngSwitch]="checkController(controller)">
        <span *ngSwitchCase="'required'" translate>FORM_ERROR_REQUIRED</span>
        <span *ngSwitchCase="'minlength'" translate>FORM_ERROR_REQUIRED</span>
        <span *ngSwitchDefault translate>FORM_ERROR_REQUIRED</span>
    </div> -->
  <span>{{ checkController(controller) }}</span>
</div>
